<app-purchase-order-grid
    #purchaseOrderGridComponent
    [permissionKey]="'purchaseOrders.list'"
    [filter]="['ThirdId.Id eq ' + element.Id]"
    (add)="onAddButtonClicked()"
    [canDelete]="true"
    [showPager]="false"
    [columns]="PurchaseOrderColumns"
></app-purchase-order-grid>